import * as React from 'react';
import { useCallback, useState } from 'react';
import { reachGoal, UserGoal } from '../../../../../analytics';
import { LoginFormModal } from '../../../../../LoginPage';
const Login = props => {
    const [isLoginPageOpened, setLoginPageOpened] = useState(false);
    const [preselectedLogin, setPreselectedLogin] = React.useState('');
    const onOpenLogin = (preselectedLogin) => {
        setPreselectedLogin(preselectedLogin);
        setLoginPageOpened(true);
    };
    const onSuccessfulLogin = useCallback((isRegistration = false) => {
        setLoginPageOpened(false);
        reachGoal(isRegistration ? UserGoal.Registration : UserGoal.Login);
        if (props.refetchUser) {
            props.refetchUser();
        }
    }, [props.refetchUser]);
    return (React.createElement(React.Fragment, null,
        React.createElement(LoginFormModal, { modalProps: {
                isOpen: isLoginPageOpened,
                onClose: () => setLoginPageOpened(false)
            }, loginFormProps: {
                login: preselectedLogin,
                onSuccess: onSuccessfulLogin
            } }),
        props.children({
            openLogin: onOpenLogin,
            userInfo: props.userInfo,
            refetchUser: props.refetchUser,
            isLoginFormOpen: isLoginPageOpened
        })));
};
export default Login;
